import React from 'react';
import cx from 'classnames';
import Card from '../Card';
import MobileDetect from 'mobile-detect';
import MediaQuery from 'react-responsive';

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = !!md.mobile();

export default class ControlLayout extends React.Component {
  state = {
    appear: false,
    expand: true
  };
  componentDidUpdate(prevProps) {
    if (prevProps.step < 1 && this.props.step >= 1) {
      this.setState({ appear: true });
    }
    if (prevProps.step >= 1 && this.props.step < 1 && !this.props.scrolling) {
      // this.setState({ appear: false });
    }
  }

  imgFolder = './assets/img/';
  layouts = [
    {
      icon: `icons/icon_density.png`,
      img: `thumbs/Max_Density.png`,
      title: 'Max Density',
      paragraph:
        'Get the most bikes per square foot with max density layouts. These layouts are perfect when every inch counts, but they are susceptible to bike conflict and are trickier to move around in. Max Density layouts have the highest value per bike.'
    },
    {
      icon: `icons/icon_balanced.png`,
      img: `thumbs/Blend.png`,
      title: 'Balanced',
      paragraph:
        'A Balanced layout combines both Rider Friendly and Max Density layouts to get the best of both worlds. Accomodate riders that need easy-access, bike-friendly racks while still adding areas that are ultra high-density with Balanced layouts.'
    },
    {
      icon: `icons/icon_friendly.png`,
      img: `thumbs/Rider_Friendly.png`,
      title: 'Rider Friendly',
      paragraph:
        'These layouts apply to outdoor and indoor spaces. They follow APBP guidelines and are spacious enough to comfortably park bicycles with unrestricted movement and without bike-on-bike conflict. Rider Friendly layouts are recommended for greatest user satisfaction!'
    }
  ];

  render() {
    const { appear, expand } = this.state;
    const { layouts, imgFolder } = this;
    const {
      handleScrollIn,
      handleScrollOut,
      handleStepSet,
      parameters: { configuration },
      disableWaypoint,
      step
    } = this.props;

    const activeLayout = layouts.find(l => l.title === configuration);

    return (
      <Card
        stepIndex={1}
        handleStepSet={handleStepSet}
        step={this.props.step}
        maxHeight={550}
        disableWaypoint={disableWaypoint}
        expand={expand}
        appear={appear}
        handleScrollIn={this.props.step === 1 ? handleScrollIn : () => {}}
        handleScrollOut={this.props.step === 0 ? handleScrollOut : () => {}}
        header={'Layout Options'}
        scrollOut
        content={
          isMobile && window.innerWidth < 650 ? (
            <div
              className={cx({
                'control-layout-racks': true,
                single: true,
                active: false
              })}
            >
              <div className='card-selections'>
                {layouts.map(l => {
                  return (
                    <div
                      key={l.title}
                      onClick={e => {
                        e.stopPropagation();
                        this.props.actions.parameterConfiguration(l.title);
                      }}
                      className={cx({
                        'card-selection': true,
                        active: l.title === configuration
                      })}
                    >
                      <div>
                        <div>
                          {l.title === 'Rider Friendly'
                            ? 'Outdoor / Indoor'
                            : ''}
                        </div>
                        <div>{l.title}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className='subheader'>
                <img src={`${imgFolder}${activeLayout.icon}`} />
                {activeLayout.title}
              </div>

              <div className='control-layout-racks-img'>
                <img src={`${imgFolder}${activeLayout.img}`} />
              </div>
              <div className='card-paragraph'>{activeLayout.paragraph}</div>
            </div>
          ) : (
            layouts.map(layout => {
              const { title, img, icon, paragraph } = layout;
              return (
                <div
                  className={cx({
                    'control-layout-racks': true,
                    active: configuration === title
                  })}
                  onClick={() => {
                    this.props.actions.parameterConfiguration(title);
                  }}
                  key={title}
                >
                  <div className='subheader'>
                    <img src={`${imgFolder}${icon}`} />
                    <div>
                      <div>
                        {title === 'Rider Friendly' ? 'Outdoor / Indoor' : ''}
                      </div>
                      <div>{title}</div>
                    </div>
                  </div>
                  <div className='control-layout-racks-img'>
                    <img src={`${imgFolder}${img}`} />
                  </div>
                  <div className='card-paragraph'>{paragraph}</div>
                </div>
              );
            })
          )
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/ControlLayout/index.js